module.exports = __webpack_public_path__ + "img/person_2.e4235dd8.png";